import React, { useState } from "react";
import { Share2, Copy, Twitter, Facebook, Linkedin, Mail } from "lucide-react";
import "../../../css/blogs.css"; // Import the CSS file

export const SharePopup = ({ url, title }) => {
  const [isOpen, setIsOpen] = useState(false);

  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const shareLinks = [
    {
      name: "Twitter",
      icon: Twitter,
      url: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
      backgroundColor: "#1DA1F2",
    },
    {
      name: "Facebook",
      icon: Facebook,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      backgroundColor: "#4267B2",
    },
    {
      name: "LinkedIn",
      icon: Linkedin,
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      backgroundColor: "#0077b5",
    },
    {
      name: "Email",
      icon: Mail,
      url: `mailto:?subject=${encodedTitle}&body=${encodedUrl}`,
      backgroundColor: "#4B5563",
    },
  ];

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(url);
      alert("Link copied to clipboard!");
    } catch (err) {
      alert("Failed to copy the link. Please copy manually.");
    }
  };

  return (
    <div className="share-popup-container">
      <button
        onClick={() => setIsOpen((prev) => !prev)}
        aria-label="Share this article"
        className="share-popup-button"
      >
        <Share2 />
      </button>

      {isOpen && (
        <div className="share-popup-dropdown">
          <h3 className="share-popup-title">Share this article</h3>

          <div className="share-popup-links">
            {shareLinks.map((link) => (
              <a
                key={link.name}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Share on ${link.name}`}
                className="share-popup-link"
                style={{ backgroundColor: link.backgroundColor }} // Keep dynamic background color
              >
                <link.icon />
              </a>
            ))}
          </div>

          <div className="share-popup-copy-section">
            <div className="share-popup-url-display" title={url}>
              {url} {/* Display full URL, CSS handles overflow */}
            </div>
            <button
              onClick={copyToClipboard}
              aria-label="Copy link"
              className="share-popup-copy-button"
            >
              <Copy />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
